import { FC } from "react";
import { Dialog as MuiDialog } from "@mui/material";
import { DialogProps } from "./Dialog.type";

export const Dialog: FC<DialogProps> = ({ children, ...rest }) => (
  <MuiDialog {...rest}>{children}</MuiDialog>
);

export default Dialog;
